import { BaseModel } from '../../_base/crud';

export class TeamMember extends BaseModel {
  id: number;
  userName: string;
  profileUrl: any;
}
